export const theme = {
  token: {
    colorPrimary: '#1ED6FF',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1ED6FF',
    colorTextBase: '#ffffff',
    colorBgBase: '#141414',
    borderRadius: 8,
    wireframe: false,
  },
  components: {
    Layout: {
      colorBgHeader: '#141414',
      colorBgBody: '#141414',
      colorBgContainer: '#1f1f1f',
    },
    Menu: {
      colorItemBg: 'transparent',
      colorItemText: 'rgba(255,255,255,0.65)',
      colorItemTextSelected: '#1ED6FF',
      colorBgContainer: 'transparent',
      itemHoverColor: '#1ED6FF',
      itemSelectedColor: '#1ED6FF',
      horizontalItemSelectedBg: 'transparent',
      itemHoverBg: 'rgba(255,255,255,0.08)',
      itemActiveBg: 'rgba(255,255,255,0.08)',
    },
    Button: {
      colorPrimary: '#1ED6FF',
      colorPrimaryHover: '#4CE0FF',
    },
    Card: {
      colorBgContainer: '#1f1f1f',
      colorBorderSecondary: '#303030',
    },
    Select: {
      colorBgContainer: '#1A1A1A',
      colorBorder: '#2A2A2A',
      colorTextPlaceholder: 'rgba(255,255,255,0.45)',
    },
    Input: {
      colorBgContainer: '#1A1A1A',
      colorBorder: '#2A2A2A',
    }
  },
} 